'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

cbCssFeature.$inject = ['$window'];


var _module = _angular2.default.module('cb.core.cbCssFeature', []);

_module.directive('cbCssFeature', cbCssFeature);

exports.default = _module;

/**
 * This function checks if the browser supports a specific CSS feature and then adds a class to the element.
 * Takes params in it's own attribute:
 * cb-css-feature="CSSFeature,CSSFeatureValue,ClassToAddToElement"
 * Examle:
 * cb-css-feature="mix-blend-mode,multiply,css-supports-mix-blend-mode"
 *
 * If the browser supports CSS "mix-blend-mode: multiply" the class css-supports-mix-blend-mode is added to the element.
 */

function cbCssFeature($window) {
    return {
        restrict: 'A',
        link: CssFeature
    };

    function CssFeature(scope, element, attr) {

        var detect = attr.cbCssFeature.split(',');
        if (detect.length < 3) {
            return;
        }

        if ($window.CSS && $window.CSS.supports) {
            if ($window.CSS.supports(detect[0], detect[1])) {
                element[0].classList.add(detect[2]);
            }
        } else {
            if (element[0].style[detect[0]]) {
                element[0].classList.add(detect[2]);
            }
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/cb-css-feature.directive.js
// module id = 769
// module chunks = 0